var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93163 17C5.93163 13.5636 8.83686 10.7778 12.4206 10.7778C13.0649 10.7778 13.6872 10.8678 14.2746 11.0355M18.1727 11.7067V17M1 17C1 14.8751 2.79761 13.1526 5.01507 13.1526C5.41371 13.1526 5.79875 13.2083 6.16223 13.3119M21 14.3333H15.438M16.1286 4.55556C16.1286 6.51924 14.4685 8.11111 12.4206 8.11111C10.3728 8.11111 8.71263 6.51924 8.71263 4.55556C8.71263 2.59188 10.3728 1 12.4206 1C14.4685 1 16.1286 2.59188 16.1286 4.55556ZM7.30939 9.30519C7.30939 10.5194 6.28217 11.5037 5.01507 11.5037C3.74795 11.5037 2.72074 10.5194 2.72074 9.30519C2.72074 8.09098 3.74795 7.10667 5.01507 7.10667C6.28217 7.10667 7.30939 8.09098 7.30939 9.30519Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileInvite);
export default __webpack_public_path__ + "static/media/mobile-invite.3ece71f18203faf50842bc4aae819659.svg";
export { ForwardRef as ReactComponent };